import './App.css'
import { Route, Routes } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  CARGO_FORM_ROUTE,
  CARGO_ITEM_ROUTE,
  CARGO_ROUTE,
  MAIN_ROUTE,
  PERSONAL_DATA_AGREEMENT_ROUTE,
  PRIVACY_POLICY_ROUTE,
  SLOT_FORM_ROUTE,
  SLOT_ITEM_ROUTE,
  SLOT_ROUTE,
  TRANSPORT_FORM_ROUTE,
  TRANSPORT_ITEM_ROUTE,
  TRANSPORT_ROUTE,
  USER_AGREEMENT_ROUTE,
  USER_ROUTE,
  SETTINGS_ROUTE,
  INFO_ROUTE,
  LOGIN_ROUTE,
  CATEGORY_ROUTE,
  STORE_ROUTE,
  ORDER_ROUTE,
  CLUSTER_ROUTE,
  SALE_ITEM_ROUTE,
  PROMO_ROUTE,
  STOCK_ROUTE,
  PRICE_ROUTE,
  PLACE_ROUTE,
  EXECUTOR_ROUTE,
  MOTIVATION_ROUTE,
  COMPLEX_ORDER_ROUTE,
  CAT_UPLOAD_ROUTE,
  DOCUMENT_ROUTE,
  TASK,
  DASHBOARD_ROUTE,
} from './common/utils/constants'
import { Protected } from './common/components/protected/Protected'
import { User } from './pages/user/User'
import { Settings } from './pages/settings/Settings'
import { CargoItem } from './pages/items/cargoItem/CargoItem'
import { SlotItem } from './pages/items/slotItem/SlotItem'
import { TransportItem } from './pages/items/transportItem/TransportItem'
import { PrivacyPolicy } from './pages/legality/privacyPolicy/PrivacyPolicy'
import { UserAgreement } from './pages/legality/userAgreement/UserAgreement'
import { PersonalDataAgreement } from './pages/legality/personalDataAgreement/PersonalDataAgreement'
import { SlotForm } from './pages/forms/slotForm/SlotForm'
import { CargoForm } from './pages/forms/cargoForm/CargoForm'
import { TransportForm } from './pages/forms/transportForm/TransportForm'
import { Transport } from './pages/transport/Transport'
import { Slot } from './pages/slot/Slot'
import { Cargo } from './pages/cargo/Cargo'
import { HelmetProvider } from 'react-helmet-async'
import NotFound from './pages/notFound/NotFound'
import { Info } from './pages/info/Info'
import { Category } from './pages/sales/category/Category'
import { Store } from './pages/sales/store/Store'
import { Order } from './pages/sales/order/Order'
import { Cluster } from './pages/sales/cluster/Cluster'
import { SaleItem } from './pages/sales/saleItem/SaleItem'
import { Promo } from './pages/sales/promo/Promo'
import { Stock } from './pages/sales/stock/Stock'
import { Price } from './pages/sales/price/Price'
import { MainNew } from './pages/mainNew/MainNew'
import { Place } from './pages/sales/place/Place'
import { Motivation } from './pages/sales/motivation/Motivation'
import { Executor } from './pages/sales/executor/Executor'
import { ComplexOrder } from './pages/sales/complexOrder/ComplexOrder'
import { CatUpload } from './pages/sales/catUpload/CatUpload'
import { Document } from './pages/sales/document/Document'
import { Task } from './pages/sales/task/Task'
import { TaskDetails } from './pages/sales/taskDetails/TaskDetails'
import { Dashboard } from './pages/dashboard/Dashboard'
import { selectClusterList } from './store/slices/clusterListSlice'
import { selectCurrentUser } from './store/slices/currentUserSlice'

const MainSwitch = () => {
  const clusters = useSelector(selectClusterList)
  const currentUser = useSelector(selectCurrentUser)
  return clusters.length && currentUser ? <Dashboard /> : <MainNew />
}

function App() {
  return (
    <HelmetProvider>
      <Routes>
        <Route path={MAIN_ROUTE} element={<MainSwitch />} />
        <Route path={LOGIN_ROUTE} element={<MainNew />} />
        <Route path={INFO_ROUTE} element={<Info />} />
        <Route path={PRIVACY_POLICY_ROUTE} element={<PrivacyPolicy />} />
        <Route path={USER_AGREEMENT_ROUTE} element={<UserAgreement />} />
        <Route path={PERSONAL_DATA_AGREEMENT_ROUTE} element={<PersonalDataAgreement />} />
        <Route path={SLOT_ROUTE} element={<Slot />} />
        <Route path={`${SLOT_ROUTE}/:pageType`} element={<Slot />} />
        <Route path={CARGO_ROUTE} element={<Cargo />} />
        <Route path={`${CARGO_ROUTE}/:pageType`} element={<Cargo />} />
        <Route path={CARGO_ROUTE} element={<Cargo />} />
        <Route path={TRANSPORT_ROUTE} element={<Transport />} />
        <Route path={`${TRANSPORT_ROUTE}/:pageType`} element={<Transport />} />
        <Route path={`${CARGO_ITEM_ROUTE}/:id`} element={<CargoItem />} />
        <Route path={`${SLOT_ITEM_ROUTE}/:id`} element={<SlotItem />} />
        <Route path={`${TRANSPORT_ITEM_ROUTE}/:id`} element={<TransportItem />} />

        <Route path="*" element={<NotFound />} />
        <Route element={<Protected />}>
          <Route path={CARGO_FORM_ROUTE} element={<CargoForm />} />
          <Route path={TRANSPORT_FORM_ROUTE} element={<TransportForm />} />
          <Route path={SLOT_FORM_ROUTE} element={<SlotForm />} />
          <Route path={USER_ROUTE} element={<User />} />
          <Route path={`${SLOT_FORM_ROUTE}/:id`} element={<SlotForm />} />
          <Route path={`${CARGO_FORM_ROUTE}/:id`} element={<CargoForm />} />
          <Route path={`${TRANSPORT_FORM_ROUTE}/:id`} element={<TransportForm />} />
          <Route path={SETTINGS_ROUTE} element={<Settings />} />
          <Route path={CATEGORY_ROUTE} element={<Category />} />
          <Route path={STORE_ROUTE} element={<Store />} />
          <Route path={ORDER_ROUTE} element={<Order />} />
          <Route path={COMPLEX_ORDER_ROUTE} element={<ComplexOrder />} />
          <Route path={CLUSTER_ROUTE} element={<Cluster />} />
          <Route path={SALE_ITEM_ROUTE} element={<SaleItem />} />
          <Route path={PROMO_ROUTE} element={<Promo />} />
          <Route path={STOCK_ROUTE} element={<Stock />} />
          <Route path={PRICE_ROUTE} element={<Price />} />
          <Route path={PLACE_ROUTE} element={<Place />} />
          <Route path={CAT_UPLOAD_ROUTE} element={<CatUpload />} />
          <Route path={EXECUTOR_ROUTE} element={<Executor />} />
          <Route path={MOTIVATION_ROUTE} element={<Motivation />} />
          <Route path={DOCUMENT_ROUTE} element={<Document />} />
          <Route path={DASHBOARD_ROUTE} element={<Dashboard />} />
          <Route path={TASK} element={<Task />} />
          <Route path={`${TASK}/:id`} element={<TaskDetails />} />
        </Route>
      </Routes>
    </HelmetProvider>
  )
}

export default App
